module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-48x48-e8146f52a911a0450ee9d75a481a5a15.png";